<div *ngIf="agriAvailable" class="container mt-4" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong> Schedule-3 <br> (Particulars of Income from Agriculture) </strong>

        </div>
    </div>
    <div class="row my-5">
      <div class="col-sm-5">Name of the Taxpayer: {{returnData?.profileData?.assesName}}</div>
      <div class="col-sm-7 text-right">
          TIN:
          <span class="ml-3" style="white-space: nowrap;">
              <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
          </span>
      </div>
  </div>
    <div class="row mt-4">
        <div class="col-4">Nature of Agriculture:</div>
        <div class="col-2">
            {{returnData?.headSummery?.agricultureSummery?.agricultureTypes.join(', ')}}
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr class="text-center">
                        <td width="10%">Serial <br> </td>
                        <td width="60%">Summary of Income </td>
                        <td width="30%">Amount in Taka </td>
                    </tr>
                    <tr>
                        <td width="10%">1.</td>
                        <td width="60%">Sales / Turnover / Receipt</td>
                        <td width="30%">{{data?.sales | currencySeparatorBD}}</td>
                    </tr>
                    <tr>
                        <td width="10%">2.</td>
                        <td width="60%">Gross Profit</td>
                        <td width="30%">{{data?.netProfit | currencySeparatorBD}}</td>
                    </tr>
                    <tr>
                        <td width="10%">3.</td>
                        <td width="60%">General Expenses, Selling Expenses, Land Revenue, Rates, Loan Interest, Insurance Premium and Other Expenses</td>
                        <td width="30%">{{data?.cost | currencySeparatorBD}}</td>
                    </tr>
                    <tr>
                        <td width="10%">4.</td>
                        <td width="60%">Net Profit ( 2 – 3) </td>
                        <td width="30%">{{result | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
